import React, { useEffect, useState } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { useSelector } from 'react-redux';
import * as tribunalAPI from '@debbie/cortex/dist/api/tribunal.js';
import { GLcourts } from '@debbie/common/dist/court/countries/greenland.js';
import { getDebtorsOnCustomer } from '@debbie/common/dist/customers/index.js';
import { isDocumentFoundation } from '@debbie/common/dist/documents/index.js';
import { GLTribunalJobType, } from '@debbie/common/dist/tribunal/jobs/countries/greenland.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import { h } from '@debbie/cortex/dist/index.js';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors.js';
import { selectCustomerById } from '@debbie/cortex/dist/customers/selectors.js';
import { encodeText, parseText } from '../../../../utils/templates.js';
import Button from '../../../Button.js';
import Errors from '../../../Errors.js';
import File from '../../../File/index.js';
import { fromHtml, toHtml, toPlaintext } from '../../../interactions/utils.js';
import CourtSelector from '../common/CourtSelector.js';
import EconomySettings from '../common/EconomySettings.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import { getMentionSuggestions } from '@debbie/common/dist/templates/suggestions.js';
import { TemplateType } from '@debbie/common/dist/templates/index.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
const Fogedbegaering = (props) => {
    const lang = useSelector((s) => s.lang);
    const singleCase = useSelector((s) => selectCaseById(s, Number(props.caseSequentialId)));
    const tenant = useSelector(selectTenant);
    const customer = useSelector((s) => singleCase && selectCustomerById(s, singleCase.customerId));
    const documentsLoadable = useDocumentsByReference(singleCase?.caseId);
    const documents = h.hasData(documentsLoadable) ? documentsLoadable.data : null;
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? propertyTypesLoadable.data
        : undefined;
    const mentionSuggestions = getMentionSuggestions(lang, TemplateType.LETTER, propertyTypes || undefined, tenant);
    const [data, setData] = useState(props.resending
        ? {
            ...props.prefill,
            court: GLcourts.find((c) => c.courtId === props.prefill.courtId) ?? null,
            editorState: fromHtml(encodeText(props.prefill.emailHTML, mentionSuggestions)),
        }
        : {
            courtFee: 30000,
            sendInfoToEconomyResponsible: true,
            economyResponsibleUserId: localStorage.getItem('economyResponsibleUserId'),
            addCourtFeeToClientBilling: false,
            addCourtFeeToCase: true,
            addCourtDisbursementToClientBilling: false,
            court: null,
            editorState: fromHtml(encodeText(emailHTML, mentionSuggestions)),
        });
    useEffect(() => {
        if (customer) {
            const debtors = getDebtorsOnCustomer(customer);
            if (debtors.length > 0) {
                const debtor = debtors[0];
                if (debtor.details.courtId) {
                    const court = GLcourts.find((c) => c.id === debtor.details.courtId);
                    if (court) {
                        setData((s) => ({ ...s, court: court }));
                    }
                }
            }
        }
    }, [customer]);
    const foundations = documents &&
        documents.filter((document) => isDocumentFoundation(document) &&
            (document.signedFile || document.file));
    const foundation = foundations && foundations[0];
    const foundationFile = foundation && (foundation.signedFile || foundation.file);
    const getData = () => {
        if (data.court?.courtId == null) {
            throw new Error(`No court selected`);
        }
        if (foundation == null) {
            throw new Error(`No foundation`);
        }
        return {
            ...data,
            foundationDocumentId: foundation.documentId,
            courtId: data.court.courtId,
            emailHTML: parseText(toHtml(data.editorState), mentionSuggestions),
            emailBody: parseText(toPlaintext(data.editorState), mentionSuggestions),
        };
    };
    const submitter = useMutation(() => {
        const data = getData();
        console.log(data);
        if (singleCase?.caseId) {
            return tribunalAPI.createTribunalJob({
                type: props.resending
                    ? GLTribunalJobType.ResendFogedbegaering
                    : GLTribunalJobType.CreateFogedbegaering,
                tribunalCaseId: props.resending ? props.tribunalCaseId : undefined,
                data: data,
                caseId: singleCase?.caseId,
                reference: null,
            });
        }
    }, {
        onSuccess: () => {
            if (props.onCreated) {
                props.onCreated();
            }
        },
    });
    const canSubmit = data.court != null && foundationFile;
    return (React.createElement("div", null,
        React.createElement("h3", null, lang.tribunal.jurisdiction),
        React.createElement(CourtSelector, { courts: GLcourts, value: data.court, onChange: (court) => {
                setData((s) => ({ ...s, court }));
            } }),
        React.createElement("h3", null, "Email tekst"),
        React.createElement(Editor, { stripPastedStyles: true, onEditorStateChange: (es) => {
                setData((s) => ({ ...s, editorState: es }));
            }, editorState: data.editorState, mention: {
                separator: ' ',
                trigger: '@',
                suggestions: mentionSuggestions.map((suggestion) => ({
                    value: suggestion.label,
                    text: suggestion.label,
                    url: suggestion.label,
                })),
            } }),
        React.createElement("h3", null, lang.tribunal.economy),
        React.createElement(EconomySettings, { value: data, onChange: (es) => setData((s) => ({ ...s, ...es })) }),
        React.createElement("h3", null, lang.tribunal.foundation),
        foundationFile ? (React.createElement(File, { file: foundationFile })) : (React.createElement("p", null, lang.tribunal.noFoundation)),
        submitter.isError && submitter.error instanceof Error && (React.createElement(Errors, { errors: [submitter.error.message] })),
        React.createElement(Button, { onClick: () => submitter.mutate(), loading: submitter.isLoading, block: true, disabled: !canSubmit }, lang.tribunal.createFogedrekvisition)));
};
export default Fogedbegaering;
const emailHTML = `<p><strong>Fogedbegæring</strong></p>
<p>{{debtor.name}}&nbsp;</p>
<p>{{debtorAddressFormatted}}&nbsp;</p>
<p>{{debtor.phone.number}}</p>
<p>E-mail: {{debtor.email}}</p>
<p>har ikke overholdt sine forpligtelser overfor min klient</p>
<p>{{case.creditor.name}}</p>
<p>{{case.creditor.address.address}}&nbsp;</p>
<p>CVR nr. {{creditorCentralRegisterId}}&nbsp;</p>
<p>v/ advokat Iris Ohms Jørgensen</p>
<p>v/ advokatfuldmægtig Christian Vollstedt</p>
<p>hvorfor debitor bedes tilsagt til fogedretten i medfør af retsplejelovens § 604.</p>
<p>Jeg vedlægger sagens fundament og fordringen opgøres således:</p>
<p>{{{debt.overview}}}</p>
<p>samt yderligere renter og omkostninger ved fogedforretningens foretagelse.</p>
<p>Skyldneren bedes indkaldt til fogedretsmøde og fogedretten anmodes om at foretage udlæg i debitors effekter, særligt i fast ejendom, løsøre, skibe, bank- og sparekassebeholdninger, værdipapirer, arbejds- og andre tilgodehavender.</p>
<p>Fogedretten er bemyndiget til at indgå afdragsordninger med skyldneren, såfremt sådan ordning findes rimelig og fornuftig. Også i tilfælde heraf bedes der foretaget udlæg til sikkerhed.</p>
<p>Min klients godkendelse af enhver afdragsordning forbeholdes.</p>
<p>Ejer skyldneren ikke udlægsegnede genstande og kan gælden ikke afvikles indenfor overskuelig tid, ønskes sagen tilbagesendt med bemærkning herom.</p>
<p>Såfremt skyldner tilbyder en afdragsordning, bedes ordningen straks iværksat, således at skyldner indbetaler de tilbudte afdrag til mit kontors konto i GrønlandsBANKEN A/S på konto:</p>
<p>{{payment.id}}&nbsp;</p>
<p>eller ved fast overførsel til kontonummer {{collector.registrationNumber}}-{{collector.accountNumber}} med reference til sagsnummer {{journalNumber}}.&nbsp;</p>
<p>Kopi af kvittering for overførsel af retsafgift kr. 300,00 til konto i GrønlandsBANKEN A/S konto nr. {{court.registrationnumber}}-{{court.accountnumber}} vedlægges.</p>
<p></p>
<p>Nuuk, den {{date}}&nbsp;</p>
<p></p>
<p>Christian Vollstedt</p>
`;
//# sourceMappingURL=Fogedbegaering.js.map